export const MANAGE_RESOURCE_TYPE = {
  LESSON: {
    value: "LESSON",
    label: "manage_resource_filter_lesson_label",
  },
  MEDIA: {
    value: "MEDIA",
    label: "manage_resource_filter_media_label",
  },
  CONTENTMAP: {
    value: "CONTENTMAP",
    label: "manage_resource_filter_content_map_label",
  },
  APP: {
    value: "APP",
    label: "manage_resource_filter_app_label",
  },
  WEBSITE: {
    value: "WEBSITE",
    label: "manage_resource_filter_website_label",
  },
};
export const LOCATION = {
  MOE: {
    value: "MOE",
    label: "manage_resource_filter_location_moe_library",
  },
  APP: {
    value: "APP",
    label: "manage_resource_filter_location_app_library",
  },
  EXTERNAL_RESOURCES: {
    value: "EXTERNAL_RESOURCES",
    label: "manage_resource_filter_location_external_resources",
  },
};

export const LESSON_TYPE_OPTIONS = {
  ALL: { value: "ALL", label: "manage_resource_filter_resource_type_all", name: "0" },
  LESSON: { value: "LESSON", label: "manage_resource_filter_resource_type_lesson", name: "1" },
  COURSE: { value: "COURSE", label: "manage_resource_filter_resource_type_course", name: "2" },
};

export const MEDIA_TYPE_OPTIONS = {
  ALL: { value: "ALL", label: "manage_resource_filter_resource_type_all", name: "0" },
  IMAGE: { value: "IMAGE", label: "manage_resource_filter_resource_type_images", name: "1" },
  VIDEO: { value: "VIDEO", label: "manage_resource_filter_resource_type_videos", name: "2" },
  HTML5: { value: "HTML5", label: "manage_resource_filter_resource_type_interactives", name: "3" },
  AUDIO: { value: "AUDIO", label: "manage_resource_filter_resource_type_audio", name: "4" },
  POWERPOINT: {
    value: "POWERPOINT",
    label: "manage_resource_filter_resource_type_powerpoint",
    name: "5",
  },
  WORD: { value: "WORD", label: "manage_resource_filter_resource_type_word", name: "6" },
  EXCEL: { value: "EXCEL", label: "manage_resource_filter_resource_type_excel", name: "7" },
  PDF: { value: "PDF", label: "manage_resource_filter_resource_type_pdf", name: "8" },
  ZIP: { value: "ZIP", label: "manage_resource_filter_resource_type_zip", name: "9" },
  OTHERS: { value: "OTHERS", label: "manage_resource_filter_resource_type_others", name: "10" },
};

export const MEDIA_TYPE = {
  AUDIO: { value: "AUDIO", displayName: "Audio" },
  HTML5: { value: "HTML5", displayName: "HTML5" },
  IMAGE: { value: "IMAGE", displayName: "Image" },
  VIDEO: { value: "VIDEO", displayName: "Video" },
  EXCEL: { value: "EXCEL", displayName: "Excel" },
  POWERPOINT: { value: "POWERPOINT", displayName: "PowerPoint" },
  WORD: { value: "WORD", displayName: "Word" },
  PDF: { value: "PDF", displayName: "PDF" },
  ZIP: { value: "ZIP", displayName: "Zip" },
  OTHERS: { value: "OTHERS", displayName: "Others" },
};

export const PACKAGE_TYPE = {
  LESSON: "NEW",
  COURSE: "COURSE",
};

export const APP_AVAILABILITY_TYPE = {
  GLOBAL: "GLOBAL",
  SCHOOL: "SCHOOL",
};

export const STATUS = {
  ALL: { value: "ALL", label: "manage_resource_filter_status_all" },
  DRAFT: { value: "DRAFT", label: "manage_resource_filter_status_draft" },
  PENDING_APPROVAL: {
    value: "PENDING_APPROVAL",
    label: "manage_resource_filter_status_pending_approval",
  },
  APPROVED: { value: "APPROVED", label: "manage_resource_filter_status_approved" },
  REJECTED: { value: "REJECTED", label: "manage_resource_filter_status_rejected" },
  UNPUBLISHED: { value: "UNPUBLISHED", label: "manage_resource_filter_status_unpublished" },
  PENDING_UNPUBLISH: {
    value: "PENDING_UNPUBLISH",
    label: "manage_resource_filter_status_pending_unpublish",
  },
  ARCHIVED: { value: "ARCHIVED", label: "manage_resource_filter_status_archived" },
};

export const MEDIA_OBJECT_STATUS = {
  ALL: { value: "ALL", label: "manage_resource_filter_status_all" },
  DRAFT: { value: "DRAFT", label: "manage_resource_filter_status_draft" },
  PENDING_APPROVAL: {
    value: "PENDING_APPROVAL",
    label: "manage_resource_filter_status_pending_approval",
  },
  APPROVED: { value: "APPROVED", label: "manage_resource_filter_status_approved" },
  REJECTED: { value: "REJECTED", label: "manage_resource_filter_status_rejected" },
  UNPUBLISHED: { value: "UNPUBLISHED", label: "manage_resource_filter_status_unpublished" },
};

export const MAXIMUM_BULK_REMOVE_TAGGINGS = 10;

export const MEDIA_UPLOAD_MINIMUM_LOADING_DURATION_MS = 5000;
